<template>
  <div class="ml-2 ml-md-4 ml-sm-2 mr-4 pb-3">
    <custom-result-not-found v-if="assistanceSummariesModel.length == 0" />
    <div
      v-for="(item, index) in assistanceSummariesModel"
      :key="`attendance-additional-${index}`"
    >
      <div class="row bg-secondary-9 rounded p-4 mb-3">
        <div class="col">
          <div>
            <span class="color-secondary-6 font-14 font-weight-normal">
              Servicio:
            </span>
            <span class="color-black font-16 font-weight-normal pl-2">
              {{ item.serviceDescription }}
            </span>
          </div>
        </div>
        <div class="col d-flex justify-content-end align-items-center">
          <em
            class="font-18 cursor-pointer"
            :class="toggleClass(item.isOpen)"
            @click="onOpenHandler(index)"
          />
        </div>
      </div>
      <validation-provider
        v-slot="{ errors }"
        :disabled="getSelectedItems().length > 0"
        rules="required"
      >
        <div
          v-if="item.isOpen"
          class="row bg-secondary-9 rounded py-3 mb-3 mt-n2"
        >
          <div v-if="item.assistanceSummaries.length == 0" class="col">
            <custom-result-not-found />
          </div>
          <div
            v-for="(itemChild, indexChild) in item.assistanceSummaries"
            :key="`item-index-${indexChild}`"
            class="col-3 mt-3"
          >
            <custom-checkbox-single-option
              v-model="itemChild.selected"
              class="check-field"
              custom-error-msg=""
              :error="errors[0] && getSelectedItems().length == 0"
              :option-text="periodDescription(itemChild)"
              @input="setList(itemChild)"
            />
          </div>
        </div>
        <custom-error
          v-if="errors[0] && item.isOpen"
          message="Favor seleccionar uno o varios periodos para completar el proceso de Documentar comentarios adicionales."
          variant="no-border mb-3"
        />
      </validation-provider>
    </div>
  </div>
</template>

<script>
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import CustomResultNotFound from 'custom-result-not-found';
import CustomError from 'custom-error';
import { Colors } from '@/components/common';
import alertMixin from '@/mixins/alert.mixin';

const statusEnum = Object.freeze({
  pending: 1,
  approved: 2,
  denegate: 3,
  review: 5,
  no_payment: 6,
  payment: 7,
});

export default {
  name: 'AdditionalChildSection',
  components: {
    CustomCheckboxSingleOption,
    CustomError,
    CustomResultNotFound,
  },
  mixins: [alertMixin],
  props: {
    assistanceSummaries: {
      type: Array,
      default: () => [],
    },
    showStatusIndicator: {
      type: Boolean,
      default: () => false,
    },
    messageError: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      assistanceSummariesModel: this.assistanceSummaries,
    };
  },
  computed: {
    toggleClass() {
      return (opened) =>
        opened
          ? 'fas fa-angle-down color-green'
          : `fas fa-angle-right color-orange`;
    },
    periodDescription() {
      if (this.showStatusIndicator) {
        return (
          item
        ) => `<div class="color-secondary-6 font-14">Periodo: </div> 
         <div class="color-black font-16">${item.period}</div>
         <div class="fa fa-circle font-12 color-${this.getColor(
           item.statusId
         )}"></div>
         <span class="color-black font-16 ml-1">${item.statusName}</span>`;
      } else {
        return (
          item
        ) => `<div class="color-secondary-6 font-14">Periodo: </div> 
         <div class="color-black font-16">${item.period}</div>`;
      }
    },
    getColor() {
      return (status) => {
        switch (status) {
          case statusEnum.payment:
            return 'primary-15';
          case statusEnum.approved:
            return 'green-light';
          case statusEnum.pending:
          case statusEnum.no_payment:
            return Colors.YELLOW;
          case statusEnum.denegate:
            return Colors.BROWN;
          default:
            return 'secondary-19';
        }
      };
    },
  },
  watch: {
    assistanceSummariesModel: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.$emit('on-set-list', this.getSelectedItems());
        }
      },
    },
  },
  methods: {
    setList(item) {
      this.$emit('on-set-list', item.assistanceSummaryId);
    },
    onOpenHandler(index) {
      this.assistanceSummariesModel = this.assistanceSummariesModel.map(
        (item, itemIndex) => {
          if (index == itemIndex) {
            item.isOpen = !item.isOpen;
          }
          return item;
        }
      );
    },
    getSelectedItems() {
      let arr = [];
      this.assistanceSummariesModel.forEach((item) => {
        arr = [
          ...arr,
          ...item.assistanceSummaries
            .filter((x) => x.selected)
            .map((x) => x.assistanceSummaryId),
        ];
      });
      return arr;
    },
  },
};
</script>

<style scoped lang="scss">
.gradient-border {
  box-shadow: 8px 0 3px -3px #efefef !important;
}

@media only screen and (max-width: 768px) {
  .date-container {
    padding-right: -10px !important;
    .fulldate {
      font-size: 11px !important;
    }
    .hour {
      font-size: 8px !important;
    }
  }

  .text-description {
    font-size: 12px !important;
    margin-left: 15px;
  }

  .text-status {
    font-size: 12px !important;
  }

  .additional-panel {
    .label-text {
      font-size: 10px !important;
    }
    .label-value {
      font-size: 12px !important;
    }
  }

  .toggle-action {
    border-left: unset !important;
  }
  .gradient-border {
    box-shadow: unset !important;
  }
}
</style>
